export default __webpack_public_path__ + "static/summer_containers46-9bc458c81cb0dbc0b761f69a9db2d2df.webp";